import Sortable from 'sortablejs';
import csrfToken from '../fn/csrfToken';

const initNode = (node) => {
  const dirtyURL = node.getAttribute('data-url');

  new Sortable(node, {
    group: 'nested',
    animation: 150,
    fallbackOnBody: true,
    swapThreshold: 0.35,
    onEnd: (event) => {
      const id = event.item.getAttribute('data-id');
      const finalURL = dirtyURL.replace('##id##', id);
      const parentNode = event.to.closest('.nested-item');
      const parentId = parentNode && parentNode.getAttribute('data-id');
      const newIndex = event.newIndex;

      console.log('SortableJS.onEnd');
      console.log(id);
      console.log(parentId);
      console.log(newIndex);

      const payload = {
        method: 'PATCH',
        body: JSON.stringify({ parent_id: parentId, insert_at: newIndex + 1 }),
        credentials: 'same-origin',
        headers: new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken(),
          'X-Requested-With': 'XMLHttpRequest',
        }),
      };

      fetch(finalURL, payload)
        .then(response => response.json())
        .then(json => console.log('success'))
        .catch(error => console.error(error));
    },
  });
};

const init = () => {
  const nodes = document.querySelectorAll('.nested-list');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', init);
};

export default { start };
